import store from '@/store'
import { appID as constAppID } from '@/const/underwriting'

export const motorProposalGeneral = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NP') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorProposalGeneral is 1
    if (quoteLifeCycle < 1 || appID !== constAppID.MOTOR) {
      // For general, can only go back to sales oppo
      next({ name: 'quotation' })
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const motorProposalDriver = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NP') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorProposalDriver is 2
    if (appID !== constAppID.MOTOR) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'motorProposal' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const motorProposalVehicle = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NP') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorProposalDriver is 2
    if (appID !== constAppID.MOTOR) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'motorProposal' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'motorProposalDriver' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const motorProposalPremium = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NP') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorProposalDriver is 2
    if (appID !== constAppID.MOTOR) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'motorProposal' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'motorProposalDriver' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'motorProposalVehicle' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}

export const motorProposalPayment = (to, from, next) => {
  if (store.state.agency.quotation.commonInfo.statusCode === 'NP') {
    const { quoteLifeCycle } = store.state.agency.quotation
    const { appID } = store.state.agency.quotation.commonForm
    // motorProposalDriver is 2
    if (appID !== constAppID.MOTOR) {
      next({ name: 'quotation' })
    } else if (quoteLifeCycle < 2) {
      if (quoteLifeCycle === 1) {
        next({ name: 'motorProposal' })
      } else if (quoteLifeCycle === 2) {
        next({ name: 'motorProposalDriver' })
      } else if (quoteLifeCycle === 3) {
        next({ name: 'motorProposalVehicle' })
      } else if (quoteLifeCycle === 4) {
        next({ name: 'motorProposalPremium' })
      } else {
        next({ name: 'quotation' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'quotation' })
  }
}
